export default {
    general: {
        delete: 'Delete',
        edit: 'Edit',
        noDataFound: 'No data found',
        treatments: 'Treatments',
        patients: 'Patients',
        machine: 'Machine',
        areas: 'Areas',
        male: 'Male',
        female: 'Female',
        other: 'Other',
        type: 'Type',
        yes: 'Yes',
        no: 'No',
        noDataToDisplay: 'No data to display',
        displayingOutOf: 'Displaying {0} - {0} out of {0}',
        expand: 'Expand',
        collapse: 'Collapse',
        download: 'Download',
        confirm: 'Confirm',
        cancel: 'Cancel',
        pageNotFound: 'Page not found',
        agree: 'Agree',
        on: 'On',
        off: 'Off',
        autodetected: 'Auto detected',
        notSelected: 'Not selected',
        roles: {
            1: 'Staff',
            2: 'Clinic',
            3: 'Chain',
            4: 'Distributor',
            5: 'Admin'
        }
    },

    machineActivity: {
        init: 'Start treatment',
        registered: 'Machine registered',
        pulses: 'Synch pulses',
        assign: 'Assign machine',
        updateMachineVersion: 'Machine version',
        addTreatment: 'Treatment details',
        endGridRound: 'End for grid',
        error: 'Machine error',
        ack: 'Pulses check',
        patient: 'Check patient exists',
        checkTreatment: 'Check staff exist'
    },

    alerts: {
        success: 'Success',
        error: 'Error',
        warning: 'Warning',
        info: 'Info'
    },

    areas: {
        'Arm': 'Arm',
        'Axila': 'Axilla',
        'Back': 'Back',
        'Back of hand': 'Back of hand',
        'Bikini': 'Bikini',
        'Buttok': 'buttock',
        'Cheek': 'Cheek',
        'Chest': 'Chest',
        'Chin': 'Chin',
        'Ear': 'Ear',
        'Eyebrow': 'Eyebrow',
        'Finger': 'Finger',
        'Glabela': 'Glabella',
        'Knee': 'Knee',
        'Lower leg': 'Lower leg',
        'Man abdomen': 'Man abdomen',
        'Man face': 'Man face',
        'Nape': 'Nape',
        'Neck': 'Neck',
        'Nose': 'Nose',
        'Shoulder': 'Shoulder',
        'Thigh': 'Thigh',
        'Toe': 'Toe',
        'Upper hand': 'Upper hand',
        'Upper lip': 'Upper lip',
        'Woman abdomen': 'Woman abdomen',
        'Woman face': 'Woman face',
    },

    login: {
        welcome: 'Welcome',
        signIn: 'Sign in',
        email: 'Email',
        password: 'Password',
        forgotPassword: 'Forgot password?',
        passwordMustBeChanged: 'Your password doesn\'t meet our requirements. For your safety, you must change it.',
        dontHaveAnAccount: 'Don\'t have an account?',
        register: 'Register',
        guide: 'Guide',
        userNamePasswordIncorrect: 'Username or password are incorrect',
        tooManyAttempts: 'Multiple failed login attempts were made. If you believe you are using the correct email and password, your account might be temporarily blocked.',
    },

    register: {
        title: 'Onboarding',
        hasAccount: 'Already have an account?',
        loginHere: 'Login Here',
        buttons: {
            COMPLETE: "Complete",
            CONTINUE: "Continue",
            PREVIOUS: "Go Back"
        },
        results: {
            SUCCESS: {
                TITLE: 'Account Successfully Created!',
                DESCRIPTION: {
                    PART_ONE: "We've just sent you an email to",
                    PART_TWO: "Check your mail and follow the instructions to activate your account."
                },
                CHECK_MOBILE: "Check SmartClinic on your Mobile Phone"
            },
            ERROR: {
                TITLE: 'Error Occurred When Creating Account!',
                TRYAGAIN: 'Try Again'
            }
        },
        errors: {
            UNKNOWN_DISTRIBUTER: 'Could not verify distributor code. Please make sure you enter the correct code & country of the distributor',
            EMAIL_ALREADY_USED: 'User email address is already in use. Please select a different email',
            GENERAL_EXCEPTION: 'Unknown error occured. Please try again later or contact our support team',
            MISSING_DISTRIBUTER_COUNTRY: 'Please select distributor country',
            MISSING_DISTRIBUTER_CODE: 'Please enter select a distributor',
            MISSING_NAME: 'Name is required',
            MISSING_PHONE: 'Phone is required',
            MISSING_ADDRESS: 'Address is required',
            MISSING_ADDRESS_DROPDOWN: 'Please select an address from the dropdown',
            MISSING_FULLNAME: 'Full name is required',
            MISSING_EMAIL: 'User email is required',
            MISSING_PASSWORD: 'Password is required',
            WRONG_PASSWORD_LENGTH: 'Password length should be at least 6 characters long',
            MISSING_AGREE: 'You must agree to our T&C and privacy policy to continue',
            EMAIL_TAKEN: 'Email already exists. Please choose a different email'
        },
        steps: {
            ACCOUNT_TYPE: {
                MENU: {
                    LABEL: 'Account Type',
                    DESCRIPTION: 'Select the type of account to create'
                },
                CONTENT: {
                    TITLE: 'Step One - Select Account Type',
                    DESCRIPTION: 'To continue, please select one the following account types. Each type has its own unique features, so make sure you select the correct type for your organization',
                    CLINIC: {
                        TITLE: 'Clinic',
                        DESCRIPTION: 'If your organization is operating as a single clinic, choose this option'
                    },
                    CHAIN: {
                        TITLE: 'Chain',
                        DESCRIPTION: 'Are you operating a chain with multiple associated clinics? Choose this option'
                    },
                }
            },
            CONNECT: {
                MENU: {
                    LABEL: 'Connect',
                    DESCRIPTION: 'Connect your organization to the right distributor'
                },
                CONTENT: {
                    TITLE: 'Step Two - Connect your',
                    DESCRIPTION: "To continue, tell us who is your organization's Alma products distributor. SmartClinic will automatically sync with your distributor, sending you important alerts and more!",
                    FIELDS: {
                        COUNTRY: {
                            LABEL: "Country",
                            DEFAULT_OPTION: "Select country from list"
                        },
                        CODE: {
                            LABEL: 'Select Distributor',
                            DEFAULT_OPTION: "Select distributor from list"
                        }
                    }
                }
            },
            ORG_DETAILS: {
                MENU: {
                    DETAILS: 'Details',
                    DESCRIPTION: 'Let us know more about your organization'
                },
                CONTENT: {
                    TITLE: 'Step Three - Details about your',
                    DESCRIPTION: "Please fill below inputs & provide details about your organization for SmartClinic to offer you the best possible experience.",
                    FIELDS: {
                        NAME: {
                            LABEL: 'Name',
                            PLACEHOLDER: 'Enter name'
                        },
                        PHONE: {
                            LABEL: 'Phone',
                            PLACEHOLDER: 'Enter phone'
                        },
                        ADDRESS: {
                            LABEL: 'Address',
                            PLACEHOLDER: 'Enter Address'
                        }
                    }
                }
            },
            USER_DETAILS: {
                MENU: {
                    LABEL: 'User Details',
                    DESCRIPTION: 'Tell us more about yourself to create a new account.'
                },
                CONTENT: {
                    TITLE: "Final Step - User Details",
                    DESCRIPTION: "Tell us more about yourself to create a new account. Choose your login email & password, which will later help you access SmartClinic.",
                    FIELDS: {
                        NAME: {
                            LABEL: "Full Name",
                            PLACEHOLDER: "Enter full name"
                        },
                        EMAIL: {
                            LABEL: "Login Email",
                            PLACEHOLDER: "Enter your email"
                        },
                        PASSWORD: {
                            LABEL: "Login Password",
                            PLACEHOLDER: "Enter your password"
                        },
                        TOS: {
                            AGREE: "I have read and agree to the",
                            TERMS: "T&C",
                            PRIVACY: "privacy policy"
                        }
                    }
                }
            }
        }
    },

    forgotPassword: {
        title: "Forgot Password",
        description: "Enter your SmartClinic email into the following form to reset your password:",
        input: {
            email: {
                label: "Email Address",
                placeholder: "Enter your email"
            },
            submit: "Submit"
        },
        goback: 'Go back to login',
        success: "Success! Please check your email to procceed with the password reset",
        error: "Error! Could not reset your password. Please try again later."
    },

    resetPassword: {
        title: "Reset Password",
        description: "Choose a new password for your SmartClinic account. Make sure it's secure & easy to remember.",
        input: {
            password: {
                label: "New Password",
                placeholder: "Enter your new password"
            },
            passwordConfirm: {
                label: "Confirm Password",
                placeholder: "Enter password again"
            },
            submit: "Reset Password"
        },
        redirect: "Redirecting you in 5 seconds",
        success: "Success! Your password was successfully changed.",
        error: "Error! Could not change your password. Please try again later.",
        errorNoMatch: "Password does not match. Make sure you type the same password"
    },

    verifyEmail: {
        title: "Your account was verified!",
        description: "Your account was successfully verified. You can now login to SmartClinic.",
        cta: "Take me to My Account",
        error: {
            title: "Error: Could not Verify Account!",
            description: "We could not verify your account. Please make sure you've clicked the right link, or check if theres another verification email on your inbox.",
            cta: "Login"
        }
    },

    menu: {
        dashboard: 'Dashboard',
        patients: 'Patients',
        clinics: 'Clinics',
        staff: 'Staff',
        equipment: 'Equipment',
        platforms: 'Platforms',
        applicators: 'Applicators',
        service: 'Service',
        treatments: 'Treatments',
        notifications: 'Notifications',
        account: 'Account',
        helpCenter: 'Help center',
        logout: 'Log out',
        clinicsAndChains: 'Clinics and Chains',
        distributors: 'Distributors',
        platformErrors: 'Platform errors',
        serviceCalls: 'Service calls',
        reports: 'Reports',
        whatsnew: "What's New",
        users: 'Users'
    },

    dashboard: {
        treatmentsGraphInfo: 'Treatment count by month',
        statistics: 'Statistics',
        activePatients: 'Active patients',
        newPatients: 'New patients',
        lastTreatments: 'Last treatments',
        area: 'Area',
        staff: 'Staff',
        date: 'Date',
        goToMachines: 'Go to platforms page',
        goToApplicators: 'Go to applicators page'
    },
    myDetails: {
        accountDetails: 'Account Details',
        english: 'English',
        spanish: 'Spanish',
        language: 'Language',
        fullName: 'Full name',
        email: 'Email',
        password: 'Password',
        accountDetailsInfo: 'View and edit your details. Email and password will be used to login to your account.',
        nameUpdatedSuccessfully: 'Name updated successfully',
        editName: 'Edit name',
        currentName: 'Current Name',
        newName: 'New name',
        notificationsMail: 'Notifications email',
        machineErros: 'Platform errors',
        machineErrosInfo: 'Choose if will be sent email from platform or not',
        changeName: 'Change name',
        emailUpdatedSuccessfully: 'Email address updated successfully',
        editEmailAddress: 'Edit email address',
        currentEmailAddress: 'Current email',
        newEmailAddress: 'New email',
        currentPassword: 'Current password',
        changeEmail: 'Change email',
        passwordUpdatedSuccessfully: 'Password updated successfully',
        editPassword: 'Edit password',
        newPassword: 'New password',
        confirmNewPassword: 'Confirm new password',
        changePassword: 'Change password',
        userCalls: 'User calls',
        timezone: 'Timezone'
    },

    account: {
        clinicNameRequired: 'Clinic name is required',
        maxLength35: 'Max length is 35 characters',
        clinicEmailRequired: 'Clinic email is required',
        enterValidEmailAddress: 'Please enter a valid email address',
        enterValidPhoneNumber: 'Please enter a valid phone number',
        imgMaxSize5mb: 'Image max size is 5MB',
        onlyImagesAllowed: 'Only images allowed',
        uploadFailed: 'Upload failed',
        clinicDetails: 'Clinic Details',
        editClinicDetails: 'Edit your clinic\'s details',
        clinicId: 'Clinic ID',
        clinicNumber: 'Clinic number',
        clinicStatus: 'Clinic status',
        clinicName: 'Clinic name',
        clinicPhoneNumber: 'Clinic phone number',
        clinicEmail: 'Clinic email',

        distributorDetails: 'Distributor details',
        editData: 'Edit details',
        alertSettings: 'Alert settings',
        systemDistributorID: 'System distributor ID, used by clinic to register',
        alertSettingsInfo: 'change alerts email and frequency',
        userAndMachineAlerts: 'Change email alerts email and frequency',
        userCallsInfo: 'Choose if will be sent email from user or not',
        machineErrorsInfo: 'Choose a frequency of sending email from machine about an error',
        distributorID: 'Distributor ID',
        changeNotificationEmail: 'Change notification email',
        newEmail: 'New email',
        changeDistributorDetails: 'Change distributor details',
        distributorContactDetails: 'Distributor contact details',
        contactEmail: 'Contact email',
        contactPhone: 'Contact phone',
        contactName: 'Contact name',

        chainDetails: 'Chain Details',
        editChainDetails: 'Edit your chain\'s details',
        chainId: 'Chain ID',
        chainNumber: 'Chain number',
        chainStatus: 'Chain status',
        chainName: 'Chain name',
        chainPhoneNumber: 'Chain phone number',
        chainEmail: 'Chain email',
        updateChainData: 'Update chain data',

        address: 'Address',
        partOfChain: 'Part of a chain',
        independent: 'Independent (Clinic doesn\'t belong to a chain)',
        success: 'Success',
        country: 'Country',
        city: 'City',
        phone: 'Phone number',
        streetAndNumber: 'Street and number',
        updateClinicData: 'Update clinic data',
        approve: 'Approve',
        decline: 'Decline',
        chainRequestApprove: 'Chain\'s request will be approved and Clinic will be added to the chain',
        chainRequestDecline: 'Chain\'s request will be declined and deleted',
        status: 'Status',
        assignmentRequests: 'Assignment Requests',
        assignmentRequestsExplain: 'Table lists the assignment requests received from chains',
        openingHours: 'Opening hours',
        weeklyHours: 'Weekly hours',
        openingHoursTooltipText: 'Clinic\'s opening hours are being used to calculate machines average usage',
        closed: 'Closed',
        logoutFromAccount: 'Log out of your account',
        logout: 'Log out',
        logoutAll: 'Log out all your devices',
        logoutAllText1: 'Are you sure you want to logout all your devices?',
        logoutAllText2: 'This includes your mobile app and any other browser you use.',
        managedByYourChain: 'These settings are managed by your chain',
        managedForAllYourClinics: 'Some of the settings cannot be changed for a specific clinic.',

        assignmentRequestsExplainForChain: 'List shows the assignment requests sent by your chain to clinics',
        addClinic: 'Assign a clinic to your chain',
        assignClinic: 'Send request to clinic',
        clinicRequestReSend: 'Re-send the assignment request to the clinic',
        clinicRequestDelete: 'Delete the request sent to the clinic',
        reSend: 'Re-send',
        delete: 'Delete',
        pending: 'Pending',
        approved: 'Approved',
        declined: 'Declined',
        clinicNumberLocation: 'The clinic number is located in the clinic\'s account page as marked in the image',

        treatmentSettings: {
            treatmentSettings: 'Treatment settings',
            staffIdAndPatientId: '[A] Staff ID and patient ID',
            staffIdAndPatientIdExplained: 'According to your selection, patient ID and staff ID will be required in order to perform a treatment',
            staffId: '[S] Staff ID',
            staffIdExplained: 'According to your selection, staff ID will be required in order to perform a treatment',
            patientId: '[P] Patient ID',
            patientIdExplained: 'According to your selection, patient ID will be required in order to perform a treatment',
            noAdditionalData: '[F] No additional data',
            noAdditionalDataExplained: 'According to your selection, patient ID and staff ID will NOT be required in order to perform a treatment',
            preparationTime: 'Preparation time',
            preparationTimeExplained: 'Preparation time is being used to calculate platforms average usage, and is automatically added for each treatment performed',
            allowedFluenceDeviation: 'Allowed fluence deviation',
            allowedFluenceDeviationExplained: 'Fluence deviation is being used to measure staff\'s accuracy',
            allowedEnergyDeviation: 'Allowed energy deviation',
            allowedEnergyDeviationExplained: 'Energy deviation is being used to measure staff\'s accuracy',
            treatmentSavedDataOptions: 'Working mode',
            treatmentSavedDataOptionsExplained: 'Select whether or not patient ID and staff ID are required to perform a treatment. We recommend choosing \'[A]: staff ID and patient ID\', to enjoy all of the Smart Clinic features',
            treatmentProtocols: 'Treatment protocols',
            viewAndEditTreatmentProtocols: 'View and edit treatment protocols',
            view: 'View',
        },
        enabled: 'Enabled',
        disabled: 'Disabled',
        error: 'Error',
        errors: 'Errors',
        changePassword: "Change password",
        currentPassword: "Current password",
        newPassword: "New password",
        newPasswordAgain: "Repeat new password",
        passwordsNoMatch: 'New password doesn\'t match new password again',
        password: 'Password',
        passwordValidation: 'Password Validation',
        name: 'Name',
        email: 'Email',
        created_at: 'Created At',
        subRole: 'Sub Role',
        editUser: 'Edit User',
        deleteUser: 'Delete User',
        accountUsers: 'Account users',
        addAccountUser: 'Add account user',
        editAccountUser: 'Edit account user',
        roles: {
            master: {
                name: 'Master',
                description: 'Can manage all users and clinics in the account',
            },
            manager: {
                name: 'Manager',
                description: 'Can manage all users in the account except master users',
            },
            viewer: {
                name: 'Viewer',
                description: 'Can only view pages. Cannot edit or delete anything',
            },
            staff: {
                name: 'Staff',
                description: 'Cannot access service, staff & report pages',
            },
            service: {
                name: 'Service',
                description: 'Does not have permissions to access or change clinics',
            },
            manufacture: {
                name: 'Manufacture',
                description: 'Cannot access service, distributors or manage clinics',
            }
        },
        save: 'Save'
    },

    notifications: {
        moreNotificationsPending: 'More notifications pending',
        noMoreNotifications: 'No more notifications',
        clinic: 'Clinic',
        machine: 'Machine',
        machineId: 'Machine ID',
        patientId: 'Patient ID',
        handle: 'Handle',
        handleId: 'Handle ID',
        skinType: 'Skin type',
        area: 'Area',
    },

    emailPreferences: {
        title: 'Email preferences',
        subtitle: 'Your current email settings for',
        intro: "Select which types of emails you’d like to receive from us",
        lists: {
            unfinishedGrid: {
                title: 'Unfinished grid',
                description: 'Get notified when a treatment is not finished properly.',
            },
            annualService: {
                title: 'Annual Service',
                description: 'We will send you an email when a machine is ready for annual service.',
            },
            newVersion: {
                title: 'New version',
                description: 'Get notified when a new machine version is available.',
            },
            scheduledReports: {
                title: 'Scheduled reports',
                description: 'Get monthly, weekly or quarterly scheduled reports from us.',
            },
            serviceCall: {
                title: 'Service Call',
                description: 'Get notified when a clinic / chain created a new service call.',
            }
        }
    },

    averageSessionsForTreatment: {
        info: 'The average number of treatments a patient will undergo for a specific area',
        header: 'Average treatment number per area',
    },

    machinesUsage: {
        header: 'Platform\'s and usage',
        info: 'Usage: Treatment time divided by clinic\'s working hours',
        usage: 'Usage',
        buyPulses: 'Buy pulses',
        overallTreatmentTime: 'Overall treatment time',
        PreparationTime: 'Preparation time',
        unusedTime: 'Unused time',
        pulses: 'Pulses',
        offline: 'Offline',
        online: 'Online',
    },

    top5Areas: {
        info: 'Top 5 Areas for each one of the machines, and the percentage of treatments.',
        header: 'Top 5 Areas',
    },

    treatmentsAnalytics: {
        info: 'Graph shows treatments grouped by areas in different periods',
        header: 'Treatments analytics',
    },

    patients: {
        clinicsPatients: 'Clinic\'s patients',
        patientId: 'Patient ID',
        patientName: 'Patient Name',
        lastTreatment: 'Last Treatment',
        area: 'Area',
        stack: 'Stack mode',
        staffName: 'Staff Name',
        staffId: 'Staff ID',
        gender: 'Gender',
        age: 'Age',
        joinedAt: 'Joined At',
        searchPatientByIdOrName: 'Search by ID or name',
        addPatient: 'Add a patient',
        updatePatient: 'Update patient',
        clinicsNewPatient: 'Clinic\'s new patients',
        viewStaff: 'View staff member',
        viewPatient: 'View patient',
        editPatient: 'Edit patient',
        deletePatient: 'Delete patient',
        deletePatientConfirm: 'Are you sure you want to delete this patient?',
        deletionIsPermanent: 'Deletion is permanent and the data cannot be restored.',
        patientCreatedSuccessfully: 'Patient created successfully',
        patientUpdatedSuccessfully: 'Patient updated successfully',
        firstName: 'First name',
        lastName: 'Last name',
        birthday: 'Birthday',
        skinType: 'Skin type',
        editPatientData: 'Edit patient data',
        addNewPatient: 'Add new patient',
        dateAndTime: 'Date & Time',
        machine: 'Platform',
        applicator: 'Applicator',
        staff: 'Staff',
        grid: 'Grid',
        pulseCount: 'Pulse #',
        fluence: 'Fluence [j/cm2]',
        temperature: 'Temperature [C]',
        energy: 'Energy [kj]',
        lasingTime: 'Lasing time [sec]',
        overallDuration: 'Overall duration [min]',
        patientsTreatments: 'Patient\'s Treatments',
        patientDetails: 'Patient Details',
        generalDetails: 'General details',
        modes: {
            all: 'All',
            current: 'Current',
            new: 'New'
        }
    },

    staff: {
        enterPlatformName: 'Enter platform name',
        numberOfTreatments: 'Number of Treatments',
        lasingTime: 'Lasing Time',
        goToStaffPage: 'Go to staff page',
        deleteStaff: 'Delete staff',
        staffId: 'Staff ID',
        staffName: 'Staff Name',
        lastTreatment: 'Last Treatment',
        joinedAt: 'Joined at',
        treatments: 'Treatments',
        addStaffMember: 'Add a staff member',
        searchStaffById: 'Search staff member',
        clinicStaff: 'Clinic\'s staff',
        chainsStaff: 'Chain\'s staff',
        selectTimePeriod: 'Select time period',
        selectYAxis: 'Select Y-Axis',
        filterByStaff: 'Filter by staff',
        showingAllStaffMembers: 'Showing all staff members',
        filterByAreas: 'Filter by areas',
        showingAllAreas: 'Showing All Areas',
        search: 'Search',
        staffPerformanceAnalysisGraph: 'Staff performance analysis graph',
        confirmDelete: 'Are you sure you want to delete this staff member?',
        deletionIsPermanent: 'Deletion is permanent and the data cannot be restored.',
        delete: 'Delete',
        allAreas: 'All areas',
        generalDetails: 'General details',
        deleteStaffMember: 'Delete staff member',
        editStaffDetails: 'Edit staff details',
        searchTreatmentsByPatientId: 'Search treatments by patient ID',
        dateAndTime: 'Date & Time',
        machine: 'Machine',
        applicator: 'Applicator',
        patientId: 'Patient ID',
        area: 'Area',
        stack: 'Stack mode',
        grid: 'Grid',
        pulseCount: 'Pulse #',
        fluence: 'Fluence [j/cm2]',
        temperature: 'Temperature [C]',
        energy: 'Energy [kj]',
        lasingTimeSec: 'Lasing time [sec]',
        overallDuration: 'Overall duration [min]',
        staffsTreatments: 'Staff\'s treatments',
        statistics: 'Statistics',
        treatment: 'Treatment',
        preparation: 'Preparation',
        hours: 'Hours',
        patients: 'Patients',
        fluenceAccuracy: 'Fluence accuracy',
        energyAccuracy: 'Energy accuracy',
        treatmentsPerPatient: 'Treatments per patient',
        patientsExplained: 'The number of patients treated by staff member',
        fluenceAccuracyExplained: 'Fluence accuracy according to treatment recommended values',
        energyAccuracyExplained: 'Energy accuracy according to treatment recommended values',
        treatmentsPerPatientExplained: 'The average number of treatments per patient, performed by staff member',
        treatmentsExplained: 'Total amount of treatments performed by staff member',
        updateStaffMember: 'Update staff member',
        name: 'Name',
        personalId: 'Personal ID',
        editStaffMember: 'Edit staff member',
        staffCreatedSuccessfully: 'Staff member added successfully',
        staffUpdatedSuccessfully: 'Staff member updated successfully',
        allErrorTypes: 'All error types',
        addStaff: 'Add a staff member',
        allClinics: 'All clinics',
        clinic: 'Clinic',
        created_at: 'Created at',
        email: 'Email',
        goToStaff: 'Go to staff page',
        last_treatment: 'Last treatment',
        personal_id: 'Personal ID',
        searchForStaffMember: 'Search for a staff member',
        selectClinic: 'Select a clinic',
        staffMembers: 'Staff members',
        cannotChangeStaffClinic: 'Staff member clinic cannot be changed',
        staffMember: 'Staff member',
        staffTreatments: 'Staff treatments',
        noDataFound: 'No data found for the selected time period'
    },

    service: {
        errorsGraph: 'Errors graph',
        service: 'Service',
        myEquipment: 'My Equipment',
        clickForMoreData: 'Click any of the following to view more data',
        noEquipment: 'No equipment registered to your clinic found',
        errorStatistics: 'Error statistics',
        contactUsTxt: 'Contact us',
        haveGeneralQuestion: 'Have a general question about our website?',
        haveProblem: 'Have a problem with one of your machines?',
        openServiceCall: 'Open a service call',
        totalErrors: 'Total errors',
        almaProductFamily: 'Alma Product Family',
        activeServiceCalls: {
            deleteServiceCall: 'Delete service call',
            createdAt: 'Created at',
            errorCode: 'Error code',
            errorName: 'Error name',
            machineId: 'Machine ID',
            machineName: 'Machine name',
            applicatorId: 'Applicator ID',
            applicatorName: 'Applicator name',
            activeServiceCalls: 'Active service calls',
            allErrors: 'All Errors',
        },
        contactUs: {
            machinesConnectionAndManagement: 'Machines connection and management',
            staffManagement: 'Staff management',
            patientsManagement: 'Patients management',
            other: 'Other',
            errorSubmittingForm: 'Error submitting form',
            successSubmittingForm: 'Your call has been received.',
            contactUs: 'Contact us',
            name: 'Name',
            enterYourName: 'Enter your name',
            email: 'Email',
            enterEmail: 'Enter your email address',
            country: 'Country',
            title: 'Title',
            machine: 'Machine',
            explainProblem: 'Explain your problem',
            submit: 'Submit',
            content: 'Content'
        },
        serviceCall: {
            serviceCallReceived: 'Your call has been received.',
            emailSent: ' We\'ve sent you a email with your call details.',
            someFieldsContainErrors: 'Some of the fields contain errors. Fix them and try again.',
            openServiceCall: 'Open a service call',
            name: 'Name',
            enterYourName: 'Enter your name',
            phoneNumber: 'Phone number',
            enterPhoneNumber: 'Enter your phone number',
            email: 'Email address',
            enterEmail: 'Enter your email address',
            country: 'Country',
            selectCountry: 'Select a country',
            city: 'City',
            selectCity: 'Enter city',
            zipCode: 'Zip code',
            enterZipCode: 'Zip code',
            address: 'Address',
            enterAddress: 'Street and number',
            distributorId: 'Distributor Id',
            isSystemDown: 'Is your system down?',
            reportNumber: 'Report number',
            callTime: 'Call will be recorded on',
            machine: 'Machine',
            selectMachine: 'Select a machine',
            machinesName: 'Machine\'s Name',
            machineId: 'Machine\'s ID',
            machineType: 'Machine type',
            ip: 'IP address',
            softwareVersion: 'Software version',
            applicator: 'Applicator',
            selectApplicator: 'Select an applicator',
            applicatorId: 'Applicator ID',
            specifications: 'Specifications',
            content: 'Content',
            explainProblem: 'Explain your problem',
            submit: 'Submit',
        },
        contactDistributor: {
            contactDistributor: 'Contact distributor',
            productName: 'Product name',
            selectProduct: 'Select a product',
            contentPlaceHolder: 'Describe your request',
            contentInitialText: 'Hello, \n\nI am reaching out to you about the product selected. \nPlease get back to me when you\'re available. \n\nThank you.'
        },

        faq: 'FAQ',
        learnMore: 'Learn more >',

        ServiceCalls: 'Service Calls',
        chainPlatformErrors: 'Chain Platform Errors',
        chainPlatformErrorsGraph: 'Chain Platform Errors Graph',
        clinicPlatformErrors: 'Clinic Platform Errors',
        clinicPlatformErrorsGraph: 'Clinic Platform Errors Graph',
        allClinics: 'All clinics',
        dateAndTime: 'Date and time',
        clinic: 'Clinic',
        systemStatus: 'System status',
        platform: 'Platform',
        applicator: 'Applicator',
        serviceNumber: 'Service number',
        text: 'Content',
        byClinic: 'By clinic',
        search: 'Search',
        searchForServiceCall: 'Search for a service call',
        systemDown: 'System down?',
        allErrorTypes: 'All error types',
        code: 'Code',
        title: 'Title',
        byError: 'By error',
        searchForError: 'Search for an error',
        notPlatformRelated: 'No platform',
        down: 'Down',
        showMessage: 'Show message',
        deleteServiceCall: 'Delete service call',
        delete: 'Delete',
        operational: 'Operational',
        notApplicatorRelated: 'No applicator',
        notClinicRelated: 'Not a specific clinic',
        platformErrors: 'Platform Errors',
        platformErrorsGraph: 'Platform Errors Graph',
        status: 'Status',
        byStatus: 'By status',
        all: 'All',
        open: 'Open',
        closed: 'Closed',
    },

    parameters: {
        areaSettingsForApplicators: 'Area settings for applicators',
        shr: 'SHR',
        shrStack: 'SHR Stack',
        skinType: 'Skin type',
        hairDensity: 'Hair density',
        fluence: 'Fluence',
        stackMode: 'Stack mode',
        numberOfPasses: 'Number of passes',
        energy: 'Energy',
        totalEnergyWithRange: 'Total Energy {0} grid (kJ)',
        areaSize: 'Area size',
        defaultWorkState: 'Default work state',
        sparse: 'Sparse',
        coarse: 'Coarse',
    },

    helpCenter: {
        videoGuides: 'Video guides',
        searchForVideo: 'Search for a video',
    },

    machines: {
        clinicPlatforms: 'Clinic\'s Platforms',
        machinesStatistics: 'Machines statistics',
        machines: 'Platforms',
        machineActivityStatus: 'Machine activity status',
        sortBy: 'Sort by',
        searchMachine: 'Search for a machine',
        nameOrId: 'Name or ID',
        machineId: 'Machine\'s ID',
        machineName: 'Machine\'s Name',
        dateAdded: 'Date added to clinic',
        detachfromdistributor: 'Detach platform from distributor',
        platformDetails: 'Platform details',
        platformUsage: 'Platform\'s usage',
        platformTreatments: 'Platform treatments',
        area: 'Areas',
        stack: 'Stack mode',
        staff: 'Staff member',
        month: 'Dates',
        serialNumber: 'Serial number',
        applicator: 'Applicator',
        daily: 'Daily',
        monthly: 'Monthly',
        numberOfTreatments: 'Number of treatments',
        selectTimePeriod: 'Select dates',
        period: 'Period',
        applicatorsRegisteredToPlatform: 'Applicators registered to platform',
        dateAndTime: 'Date and time',
        errorCode: 'Error code',
        errorName: 'Error name',
        applicatorId: 'Applicator ID',
        platformErrors: 'Platform errors',
        platformApplicators: 'Platform\'s applicators',
        noApplicatorsToDisplay: 'No applicators to display',
        updateRequired: 'Firmware update required',
        upToDate: 'Firmware up to date',
        update: 'Update firmware',
        contactSupport: 'Contact support',
        fluenceAccuracyExplained: 'Fluence accuracy according to treatment recommended values',
        energyAccuracyExplained: 'Energy accuracy according to treatment recommended values',
        usageExplained: 'Platform usage considers clinic opening hours',
        usage: 'Usage',
        energyAccuracy: 'Energy accuracy',
        fluenceAccuracy: 'Fluence accuracy',
        platformUpdateHeader: 'Platform firmware update',
        platformUpdateExplain: 'To update the platform\'s firmware to the latest version, scan the QR code',
        platformUpdateRequested1: 'You\'ve requested a firmware update for your platform.',
        platformUpdateRequested2: 'Your distributor will contact you shortly.',
        platformUpdateHavingTrouble: 'Having trouble updating?',
        platformUpdateClickHere: 'Click here',
        platformUpdateClickHereCont: 'to contact distributor about getting the latest firmware update.',
        grid: 'Grid',
        pulseCount: 'Pulse #',
        fluence: 'Fluence [j/cm2]',
        temperature: 'Temperature [C]',
        energy: 'Energy [kj]',
        lasingTime: 'Lasing time [sec]',
        overallDuration: 'Overall duration [min]',
        areaName: 'Area name',
        patient: 'Patient ID',
        platform: 'Platform',
        platforms: 'Platforms',
        platformName: 'Platform\'s name',
        enterPlatformName: 'Enter a name for the platform',
        updateName: 'Update name',
        treatments: 'Treatments',
        id: 'ID',
        newPlatformAdded: 'New platform added',
        namePlatform: 'Select a name and add it to your clinic.',
        model: 'Model',
        name: 'Name',
        addToClinic: 'Add to clinic',
        clinicPlatformsStatistics: `Clinic's Platforms Statistics`,
        chainPlatformsStatistics: `Chain's Platforms Statistics`,
        chainPlatforms: `Chain's Platforms`,
        byClinic: 'By clinic',
        searchPlatform: 'Search platform',
        platformID: 'Platform ID',
        platformNameOrId: 'Platform name or ID',
        timePeriod: 'Time period',
        timePeriodExplained: 'The time period selected only affects the usage pie chart. All of your platforms are always presented.',
        lastConnected: 'Last connected',
        goToPlatformPage: 'Go to platform\'s page',
        goToClinicPage: 'Go to clinic page',
        platformId: 'Platform ID',
        firmware: 'Platform Version',
        pieChart: {
            online: 'Online time / Clinic opening hours',
            treatment: 'Treatment time + Preparation time / Online time',
            lasing: 'Lasing time / Treatment time',
            noActivity: 'No activity',
        },
        transferPlatformToClinic: 'Transfer platform to clinic',
        transferPlatformToClinicOrDetach: 'Transfer platform to clinic / Detach',
        platformDetached: 'Platform detached',
        save: 'Save',
        unlimited: 'Unlimited',
        limited: 'Limited',
        remainingPulses: 'Remaining pulses',
        detached: 'Detached',
        detach: 'Detach',
        platformWillBeDetachedWarning: 'Platform will be detached upon approval',
        status: 'Status',
        detachedPlatforms: 'Detached platforms',
        platformsAttachedToClinics: 'Platforms attached to clinics',
        connectedToClinic: 'Date the platform was first connected to a clinic',
        clinicName: 'Clinic name',
        versionInfo: 'Version number',
        lastConnection: 'Last time platform was connected to the internet',

        versions: {
            addVersion: 'Add a new version',
            addedAt: 'Added at',
            addedBy: 'Added by',
            countryGroup: 'Country group',
            currentVersions: 'Current versions',
            manageVersions: 'Manage versions',
            module: 'Module',
            version: 'Version name',
            versionsHistoryTable: 'Versions history',
            versionsHistoryTableExplained: 'History of versions added. The newest version for each platform, country group and module is the one to be considered.',
            beCareful: 'Be careful with this. Each platform with a different version will be marked as not up to date',
            newVersion: 'New version name',
            platform: 'Platform',
            platformType: 'Platform type',
            versionNameOrNumber: 'Version name or number'
        },
        modes: {
            all: 'All',
            attached: 'Attached',
            detached: 'Detached',
            online: 'Online',
            offline: 'Offline'
        },
        allClinics: 'All clinics',
        attachedDetached: 'Attached / Detached',
        onlineStatus: 'Connection status',
        clinics: 'Clinics',
        goToClinic: 'Go to clinic',
        changeTimeLimit: 'Change Time Limit',
        timeLimit: 'Time Limit',
        unlockCode: 'Unlock Code',
    },

    applicators: {
        clinicApplicators: 'Clinic\'s applicators',
        chainApplicators: 'Chain\'s applicators',
        sortBy: 'Sort by',
        applicatorId: 'Applicator ID',
        applicatorModelName: 'Model name',
        dateAdded: 'Date added to clinic',
        searchApplicator: 'Search for an applicator',
        confirmApplicatorDeletion: 'Confirm applicator deletion',
        deletionIsPermanent: 'Deletion is permanent and the data cannot be restored',
        deleteApplicator: 'Remove applicator from clinic',
        editApplicatorSN: 'Edit applicator\'s serial number',
        addApplicatorSN: 'Add applicator\'s serial number',
        pulses: 'Pulses',
        noSpecificationsYet: 'We don\'t have the specifications for this product yet',
        handleSN: 'Applicator serial number',
        handleSnExplained: 'Your applicator\'s serial number (or SN) can be found on the sticker attached to it',
        enterHandleSN: 'Enter the applicator\'s serial number',
        updateSN: 'Update',
        allClinics: 'All clinics',
        applicators: 'Applicators',
        clinics: 'Clinics'
    },

    treatments: {
        TreatmentTypesAndProtocols: 'Treatment types & protocols',
        explain1: 'The Soprano is a diode based hair removal Platform that can treat virtually any area of the body, suitable for all skin types and all hair types.',
        explain2: 'Treatment protocol can vary between different body parts based on skin type, hair color and density & size of area treated.',
        explain3: 'The Platform enables the use of several treatment modes: SHR (Super Hair Removal), SHR Stack (stacked pulses) and HR (single pulse mode).',
        explain4: 'SHR mode is more suitable for large areas regardless of skin type or hair density and is designed so that for a given gridded area, a recommended accumulative energy is needed in order to be effective yet safe.',
        explain5: 'Working in SHR mode is in a dynamic (\'In-Motion\') technique at up to 10 Hz and in a fluence reaching up to 20 J/cm2. SHR is suitable for areas as big as 900cm2 grids and as little as 150cm2 depending on the applicator used. SHR-Stack & HR modes are used for the smaller areas (>150cm2) but are as effective as SHR. For tiny areas of persistent hair, A facial tip can be used in a puled manner.',

        treatmentsCount: 'Treatments per area',
        treatmentsCountInfo: 'Number of treatments performed for each of the areas in your clinic',
        clinicTreatments: 'Clinic\'s treatments',
        recommendedTreatmentParameters: 'Recommended treatment parameters',
        skinType: 'Skin type',
        hairDensity: 'Hair density',
        handleType: 'Handle',
        area: 'Area',
        pretreatmentProtocols: 'Treatments protocols',
        pretreatmentProtocolsInfo: 'Get the recommended treatment protocol by selecting the treatment parameters',
        sparse: 'Sparse',
        coarse: 'Coarse',
        staffId: 'Staff ID',
        nameOrId: 'Name or ID',
        patientId: 'Patient ID',

        chainTreatments: 'Chain\'s treatments',
        patientTreatments: 'Patient\'s Treatments',
        staffsTreatments: 'Staff\'s treatments',
        clinic: 'Clinic',
        staff: 'Staff',
        patient: 'Patient',
        platform: 'Platform',
        applicator: 'Applicator',
        areaName: 'Area',
        stack: 'Stack',
        mode: 'Mode',
        pulseCount: 'Pulses',
        fluence: 'Fluence',
        temperature: 'Temperature',
        energy: 'Energy',
        overallDuration: 'Duration',
        search: 'Search',
        searchForChain: 'Clinic, patient, platform or staff',
        searchForClinic: 'Patient number, platform or staff',
        byClinic: 'Filter by clinic',
        allClinics: 'All clinics',
        byArea: 'Filter by area',
        byUnfinished: 'Filter by unfinished treatments',
        allAreas: 'All areas',
        savedData: 'Saved data',
        dateAndTime: 'Time',
        platformTreatments: 'Platform\'s treatments',
        byErrorType: 'By error type',
        addTreatment: 'Add treatment',
        errorsFound: 'Errors were found. Review form inputs and try again.',
        time: 'Treatment time',
        treatmentMode: 'Treatment mode',
        frequency: 'Frequency',
        gridSize: 'Grid size',
        lasing_time: 'Lasing time [sec]',
        treatmentGrids: 'Treatment grids',
        platformNotAssociated: 'Platform is not associated with this account'
    },

    dateTime: {
        selectDate: 'Select date',
        Q: 'Q',
        dateAndTime: 'Select Time Period',
        sunday: 'Sunday',
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        hours: 'Hours',
        minutes: 'Minutes',
        days: 'Days',
    },

    chainDashboard: {
        myClinics: 'My Clinics',
        myClinicsInfo: 'Displaying all clinics registered to your chain on a map',
        clinicName: 'Clinic Name',
        clinicNumber: 'Clinic Number',
        platforms: 'Platforms',
        patients: 'Patients',
        staffMembers: 'Staff Members',
        noLocationFound: 'No location found',
        topStaffMembers: 'Top Staff Members',
        topStaffMembersInfo: 'Displaying the top staff members in your chain in selected date range',
        topStaffMembersNotFound: 'No staff members with treatments found in the selected time period.',
        topStaffMembersToSeeResults: 'To see results, you must enter staff ID when starting a treatment.',
        name: 'Name',
        treatments: 'Treatments',
        noTreatmentsInPeriod: 'No treatments in this clinic on selected period of time',
        lastTreatment: 'Last treatment',
        mostUsedApplicators: 'Most Used Applicators',
        noApplicatorsUsed: 'No applicators were in use the last 30 days',
        mostUsedApplicatorsInfo: 'Listing applicators that were used in the last 30 days only',
        pulseNumberVeryHigh: 'Pulse number is very high',
        applicatorWarrantySoonVoid: 'Applicator\'s warranty will soon be voided',
        applicatorWarrantyVoided: 'Applicator\'s warranty voided',
        orderBy: 'Order by',
        added: 'Added',
        pulseNumber: 'Pulse count',
        addedToClinic: 'Added to Clinic',
        topTreatmentsPerClinic: 'Most Popular treatments',
        topTreatmentsPerClinicInfo: 'Displaying the most popular treatment areas for each of your clinics, in a specific time period',
        lastErrors: 'Last Errors',
        lastErrorsInfo: 'Displaying the last errors reported by platforms in your chain',
        clinic: 'Clinic',
        platform: 'Platform',
        error: 'Error',
        time: 'Time',
        offlinePlatforms: 'Offline Platforms',
        offlinePlatformsInfo: 'List of platforms that were not connected for two days or more.',
        lastConnected: 'Last connection',
        platformUsageStatistics: 'Platforms Usage Statistics',
        platformUsageStatisticsInfo: 'Showing usage statistics of platforms registered to your clinics, in a selected date range',
        used: 'Used',
        unused: 'Unused',
        preparation: 'Preparation',
        clinics: 'Clinics',
        chainPatients: 'Chain Patients',
        newChainPatients: 'New Chain Patients'
    },

    clinics: {
        avgUsage: 'Avg. Usage',
        viewClinic: 'View Clinic',
        viewChain: 'View Chain',
        search: 'Search',
        chainClinics: 'Chain\'s clinics',
        searchClinic: 'Search for a clinic',
        searchByNameNumberOrId: 'Search by name, number or ID',
        clinicId: 'Clinic ID',
        deleteClinic: 'Delete Clinic',
        deletionIsPermanent: 'Do you want to delete this clinic?',
        clinicName: 'Clinic name',
        clinicChainName: 'Clinic/Chain name',
        clinicChainNumber: 'Clinic/Chain number',
        clinicNumber: 'Clinic number',
        platforms: 'Platforms',
        applicators: 'Applicators',
        patients: 'Patients',
        staff: 'Staff',
        creationDate: 'Creation date',
        phoneNumber: 'Phone number',
        address: 'Address',
        workingMode: 'Work mode',
        clinic: 'Clinic',
        chain: 'Chain',

        type: 'Type',
        clinicsAndChains: 'Clinics and Chains',
        viewReport: 'View report',
        deleteReport: 'Delete report',
        downloadReport: 'Download report',
        restoreClinic: 'Restore clinic',
        restoreThisClinic: 'Are you want to restore this clinic?',
        restore: 'Restore',
        deleteSuccessMessage: 'Clinic was deleted. You can restore it in Deleted Clinics tab.',
        restoreSuccessMessage: 'Clinic was restored.',
        modes: {
            all: 'All',
            active: 'Active',
            deleted: 'Deleted'
        }
    },
    distributors: {
        code: `Distributor's Code`,
        name: 'Distributor\'s Name',
        country: 'Country',
        totalClinics: 'Assigned Clinics & Chains',
        totalPlatforms: 'Paired Platforms',
        totalApplicators: 'Paired Applicators',
        searchDistributor: 'Search Distributor',
        searchByNameCodeOrCountry: 'Search by name, code or country',
        numberOfClinics: '# of Clinics',
        min: 'Min',
        max: 'Max',
        phone: 'Phone Number',
        email: 'Email',
        address: 'Address',
        commission: 'Commission',
        password: 'Password',
        addNewDistributor: 'Add New Distributor',
        editDistributor: 'Edit Distributor',
        addDistributor: 'Create Distributor',
        placeholders: {
            name: 'Enter distributor\'s name',
            email: 'Enter distributor\'s email',
            password: 'Distributor\'s password',
            phone: 'Distributor\'s phone number',
            address: 'Distributor\'s address',
        }
    },
    videos: {
        changeMachineTreatmentMode: 'Change platform treatment mode',
        staffPerformanceAnalysis: 'Staff performance',
        smartClinicCrashCourse: 'Get started',
        notificationsAndAlerts: 'Notifications and alerts',
        editPatientDetails: 'Edit a patient\'s data',
        addNewStaffMembers: 'Add a staff member',
        editAccountDetails: 'Edit your account',
        connectADevice: 'Connect a platform'
    },

    workingModes: {
        1: '[All] Platforms will require Patient ID and Staff ID before starting a treatment (recommended)',
        2: '[Staff only] Platforms will require only Staff ID before starting a treatment. Patients data will be lost.',
        3: '[Patient only] Platforms will require only Patient ID before starting a treatment. Staff data will be lost.',
        4: '[Free] Platforms will not require any data to start a treatment (Not recommended). All Patient and staff data will be lost.',
    },

    termsAndConditions: {
        header: 'Alma Lasers – Smart Clinic Terms of Service',
    },

    gettingStarted: {
        title: 'Getting Started with SmartClinic',
        description: "Start here if you're looking for simple ways to get started working with your SmartClinic account.",
        help: {
            title: 'Need help?',
            description: {
                partOne: 'SmartClinic has many features and is constantly being updated. We recommend you visit our',
                partTwo: 'to view more of our tutorials and guides, or contact us using the "Contact Us" button in the Help Center.',
                link: 'Help Center'
            }
        },
        showAgain: "Don't show again",
        confirm: 'Got it!',
        cards: {
            connectYourPlatform: {
                title: 'Connect a Platform',
                description: 'Easily connect your Alma platform to your SmartClinic account.',
                cta: 'Connect a Platform'
            },
            setWorkingHours: {
                title: 'Set Working Hours',
                description: 'Set your working hours and working mode',
                cta: 'Set Working Hours'
            },
            addStaffMember: {
                title: 'Add a Staff Member',
                description: 'Add the first staff member to your clinic.',
                cta: 'Add a Staff Member'
            },
            connectMyFirstClinic: {
                title: 'Connect a Clinic',
                description: 'Connect a clinic to your SmartClinic account.',
                cta: 'Connect a Clinic'
            },
            manageMyClinics: {
                title: 'Manage Clinics',
                description: 'Manage clinics associated with your SmartClinic account.',
                cta: 'My Clinics'
            },
            manageMyClinicsAndChains: {
                title: 'Manage Clinics & Chains',
                description: 'Manage clinics and chains associated with your SmartClinic account.',
                cta: 'Clinics & Chains'
            },
            manageServiceCalls: {
                title: 'Manage Service Calls',
                description: 'Manage service calls from clinics & chains under your account. Monitor platform errors and more!',
                cta: 'Service Calls'
            }
        }
    },

    tours: {
        AddStaffMember: [{
                title: 'Adding a new staff member',
                content: 'Click on this button to add a new staff member to your clinic.',
            },
            {
                title: 'Fill in the form',
                content: 'Use this dialog to add a new staff member to your clinic. You can add a new staff member by entering their name & personal id.',
                confirm: 'Okay, Got it!'
            }
        ],
        ConnectYourFirstPlatform: [{
                title: 'Your Clinic Number',
                content: 'This is your clinic number. It is used to connect your machine to the clinic. You can connect more than one machine to your clinic using this number.',
                confirm: 'Okay. What do I do next?'
            },
            {
                title: 'Connect with your Platform',
                content: `Next, you'll need to connect this number to your Alma platform. Turn on your platform, and wait for the "Register your platform" prompt to appear.`,
                confirm: 'Got it'
            }
        ],
        ConnectYourFirstClinic: [{
                title: 'Connecting your first clinic',
                content: 'Click on this button to assign a clinic to your SmartClinic chain account.',
            },
            {
                title: 'Enter clinic number',
                content: 'To connect your clinic to your SmartClinic chain account, enter the clinic number here.',
                confirm: 'Okay, Got it!'
            }
        ],
        ManageMyClinics: [{
                title: 'Manage your clinics',
                content: 'In this page you can manage clinics that you have connected to your SmartClinic chain account.',
            },
            {
                title: 'Manage your clinics',
                content: 'Each row represents a clinic in your SmartClinic chain account. You can view clinic statistics and details.',
            },
            {
                title: 'Manage your clinics',
                content: 'Click on the clinic name to view clinic details.',
                confirm: 'Okay, Got it!'
            }
        ],
        ManageServiceCalls: [{
                title: 'Manage your service calls',
                content: 'In this following table you can see all service calls created by clinics and chains under your SmartClinic distributor account. You can also filter the table by typing or selecting any of the below filter inputs.'
            },
            {
                title: 'Manage Platform Errors',
                content: 'Below you can see all errors that have occurred on any of the platforms distributed by you. You can also filter the table by typing or selecting any of the below filter inputs.'
            },
            {
                title: 'Service Errors Graph',
                content: 'Finally, you can easily see the different types of errors that have occurred on the platforms distributed by you. This graph can also be filtered by selecting a custom date range. You can also choose to group these errors by their type, or by their clinic.',
                confirm: 'Okay, Got it!'
            }
        ],
        SetMyWorkingHours: [{
                title: 'Setting your working hours',
                content: 'SmartClinic lets you set your working hours. You can set your working hours for each day of the week.'
            },
            {
                title: 'Setting your working hours',
                content: 'Make sure you enter the correct working hours for your clinic. This is important to ensure statistics about your equipment usage, efficeny and more are accurate.',
                confirm: 'Okay, Got it!'
            }
        ]
    },

    users: {
        accountUsers: 'Account users',
        name: 'Name',
        email: 'Email',
        created_at: 'Created at',
        admin: 'Alma Admin',
        all: 'All',
        chain: 'Chain',
        clinic: 'Clinic',
        distributor: 'Distributor',
        goTo: 'Go to',
        master: 'Master',
        search: 'Search',
        staff: 'Staff',
        subRole: 'Sub role',
        type: 'Type',
        viewer: 'Viewer',
        searchByUser: 'Search for a user',
        personalId: 'Personal ID',
        allUsers: 'SmartClinic Users'
    }
};